const NavActionTypes = {
  SCROLL_TO_SECTION: "SCROLL_TO_SECTION",
  SET_OVER_GALLERY: "SET_OVER_GALLERY",
};

export default NavActionTypes;
